import React from 'react';
import { Modal, Table, Typography, Icon, Alert, Button } from 'antd';
import Colors from '../themes/Colors';
import { useTranslation } from 'react-i18next';
import { getMultiplyByStatus } from '../services/display';
import { SeparateNumberFormat } from '../services/utils';
import { impressions } from '../newSrc/features/campaignManager/services/investmentCalculations';


const { Text, Paragraph } = Typography;

const UnderMinimumSpotsModal = ({
  isVisible,
  onAdjustInvestment,
  onIgnore,
  spots = [],
  editCampaignActive = false,
  currentCampaign = null
}) => {
  const { t } = useTranslation();
  
  return (
    <Modal
      closable={false}
      title={
        <div style={{ display: "flex", alignItems: "center", margin: '12px 0' }}>
            <Icon type="warning" style={{ marginRight: "10px", fontSize: "32px", color: Colors.atention }} />
            <Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("Some screens do not meet the minimum investment")}</Text>
        </div>
      }
      visible={isVisible}
      footer={[
          <Button key="ignore" onClick={onIgnore}>
            {t("Ignore and continue")}
          </Button>,
          <Button key="adjust" type="primary" onClick={onAdjustInvestment} style={{ marginLeft: "8px" }}>
            {t("Adjust investment now")}
          </Button>
      ]}
      width={700}
      >
      <div style={{ padding: "32px 24px" }}>
        <Table 
          dataSource={spots.map((displayGroup, index) => {
            const display = displayGroup.display;
            const minimumSpots = display.minimum_programmatic_spots || 0;
            const minimumPeriod = display.minimum_programmatic_period || 0;
            const cpm = display.smart_campaign_cpm || 0;
            const validationType = displayGroup.validationType || 'daily';
            const totalSpotsPerDay = displayGroup.totalSpotsPerDay;
            const campaignDays = displayGroup.campaignDays;
            
            let minimumInvestment, currentInvestment, equivalentSpots, currentSpots;
            
            if (validationType === 'daily') {
              // Daily validation
              minimumInvestment = (minimumSpots * cpm / 1000).toFixed(2);
              currentInvestment = (totalSpotsPerDay * cpm / 1000).toFixed(2);
              equivalentSpots = minimumSpots;
              currentSpots = Math.round(totalSpotsPerDay);
            } else {
              // Total validation
              const minimumSpotsPeriod = minimumSpots * minimumPeriod;
              const currentTotalSpots = displayGroup.totalSpots;
              const minimumDailyInvestment = (minimumSpots * cpm / 1000);
              minimumInvestment = (minimumDailyInvestment * minimumPeriod).toFixed(2);
              currentInvestment = (currentTotalSpots * cpm / 1000).toFixed(2);
              equivalentSpots = minimumSpotsPeriod;
              currentSpots = Math.round(currentTotalSpots);
            }
            
            const suffix = validationType === 'daily' ? '/día' : 'total';
            const multiplier = getMultiplyByStatus(editCampaignActive, currentCampaign, display);

            return {
              key: index,
              display: display.name,
              contentCount: displayGroup.contents.length,
              minimumInvestment,
              currentInvestment,
              equivalentImpressions: impressions.fromSpots(equivalentSpots, multiplier),
              currentImpressions: impressions.fromSpots(currentSpots, multiplier),
              suffix,
              cpm
            };
          })} 
          pagination={false}
          bordered
          style={{ marginBottom: '20px' }}
          className="minimum-spots-table"
        >
          <Table.Column 
            title={t("Screen")} 
            dataIndex="display" 
            key="display" 
            width="40%"
            render={(text, record) => (
              <div>
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Icon type="desktop" style={{ marginRight: "8px", color: Colors.primaryAccent, marginTop: "5px" }} />
                  <Paragraph 
                    ellipsis={{ rows: 3, expandable: true }} 
                    style={{ fontWeight: 'bold', marginBottom: 0 }}
                  >
                    {text}
                  </Paragraph>
                </div>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  {record.contentCount} {record.contentCount === 1 ? t("ad") : t("ads")}
                </Text>
                <div style={{ fontSize: '11px', marginTop: '4px' }}>
                  <Text type="secondary">CPM: ${record.cpm.toFixed(2)}</Text>
                </div>
              </div>
            )}
          />
          <Table.Column 
            title={t("Minimum investment")} 
            dataIndex="minimumInvestment" 
            key="minimumInvestment" 
            width="30%"
            align="center"
            render={(text, record) => (
              <div>
                <Text style={{ fontWeight: 'bold', fontSize: '16px' }}>
                  $ {text} {record.suffix}
                </Text>
                <div style={{ fontSize: '12px', marginTop: '4px' }}>
                  <Text type="secondary">
                    {t("Current")}: $ {record.currentInvestment} {record.suffix}
                  </Text>
                </div>
              </div>
            )}
          />
          <Table.Column
            title={t("Equivalent impressions")}
            dataIndex="equivalentImpressions"
            key="equivalentImpressions"
            width="30%"
            align="center"
            render={(text, record) => (
              <div>
                <Text
                  style={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: record.currentImpressions < text ? Colors.error : Colors.success
                  }}
                >
                  {SeparateNumberFormat(text)} {t("imp.")} {record.suffix}
                </Text>
                <div style={{ fontSize: '12px', marginTop: '4px' }}>
                  <Text type="secondary">
                    {t("Current")}: {SeparateNumberFormat(record.currentImpressions)}{' '}
                    {t("imp.")} {record.suffix}
                  </Text>
                </div>
              </div>
            )}
          />
        </Table>
        <div style={{ marginTop: '20px' }}>
          <Alert
            className='defaultAlert'
            description={t("These screens will be rejected if the minimum investment is not increased")}
            type="warning"
          />
        </div>              
      </div>
    </Modal>
  );
};

export default UnderMinimumSpotsModal;
